// extracted by mini-css-extract-plugin
module.exports = {"waitingListForm":"WaitingListForm_waitingListForm__FMUua","submitButton":"WaitingListForm_submitButton__11pKr","formError":"WaitingListForm_formError__KuLCv"};